import { FC } from "react";
import { Stack, Typography } from "@mui/material";
import { AuthErrorDetails } from "@src/apis/ModularClient";

interface Props {
  error: Partial<AuthErrorDetails>;
}

export const ErrorMessage: FC<Props> = ({ error }) => {
  return (
    <Stack mt={3}>
      <Typography color="error">An Error Occured: {error.title ?? "Please try again"}</Typography>
      {error.details && (
        <Typography variant="caption" color="error">
          {error.details}
        </Typography>
      )}
    </Stack>
  );
};
